import {defineStore} from "pinia";
import {useLoaderStore} from "@store/loader";
import axios from "axios";

const loaderStore = useLoaderStore();
export const useMetadataStore = defineStore("metadata", {
    state: () => {
        return {
            metadata: {},
            baseURL: import.meta.env.VITE_VUE_APP_ROOT_API,
            loaded: false
        };
    },

    getters: {
        getMetaData: (state) => state.metadata,
        getEndpoints: (state) => [
            state.baseURL + "/metadata?cache=true",
            // state.baseURL + "/projects?cache=true",
        ],
    },

    actions: {
        async fetchData() {
            try {
            
                const response = await axios.get(this.getEndpoints[0], 
                    { 'X-Disable-Global-Loader': true })
                const {data} = response.data;

                // Map the data to match the expected structure
                console.log(data);
                
                this.metadata = {
                    projects: data?.projects || [],
                    clientTypes: data?.['client-types'] || [],
                    serviceLines: data?.['service-lines'] || [],
                    offering: data?.offering || [],
                    users: data?.users || [],
                    industries: data?.industries || [],
                    clients: data?.clients || [],
                    documentTypes: data?.['document-types'] || [],
                    tags: data?.tags || [],
                    digitalSolution: data?.['digital-solutions'] || [],
                    managedService: data?.['managed-services'] || [],
                    businessDomains: data?.['business-domains'] || [],
                    businessUnit: data?.['business-units'] || [],
                    tracks: data?.['tracks'] || [],
                    defaultPartners: data?.['default-partners'] || [],
               
                };

                this.loaded = true;
                return this.metadata;
            } catch (error) {
                console.error('Error fetching metadata:', error);
                this.loaded = false;
                throw error;
            }
        },

        // Method to clear cache and force refresh
        async refreshData() {
            try {
                const response = await axios.get(this.baseURL + "/metadata");
                const {data} = response.data;

                // Map the data to match the expected structure
                this.metadata = {
                    projects: data.projects || [],
                    clientTypes: data['client-types'] || [],
                    serviceLines: data['service-lines'] || [],
                    offering: data.offering || [],
                    users: data.users || [],
                    industries: data.industries || [],
                    clients: data.clients || [],
                    documentTypes: data['document-types'] || [],
                    tags: data.tags || [],
                    digitalSolution: data['digital-solutions'] || [],
                    managedService: data['managed-services'] || [],
                    businessDomains: data['business-domains'] || [],
                    businessUnit: data['business-units'] || [],
                    defaultPartners: data['default-partners'] || [],
                };

                this.loaded = true;
                return this.metadata;
            } catch (error) {
                console.error('Error refreshing metadata:', error);
                this.loaded = false;
                throw error;
            }
        },

        // Method to clear the cache on the backend
        async clearCache() {
            try {
                await axios.get(this.baseURL + "/metadata/clear-cache");
                // Optionally refresh data after clearing cache
                await this.refreshData();
            } catch (error) {
                console.error('Error clearing cache:', error);
                throw error;
            }
        },

        // Method to add a new tag to the metadata
        addTag(tag) {
            if (!this.metadata.tags) {
                this.metadata.tags = [];
            }
            
            // Check if tag already exists
            const existingTag = this.metadata.tags.find(t => t.id === tag.id);
            if (!existingTag) {
                this.metadata.tags.push(tag);
                console.log('Tag added to metadata store:', tag);
            } else {
                console.log('Tag already exists in metadata store:', tag);
            }
        }
    },
});
